<template>
  <el-input
    :value="value"
    :clearable="clearable"
    :placeholder="placeholder"
    @input="onChange"
  />
</template>

<script>
export default {
  name: "Input",
  props: {
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "请输入",
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    onChange(val) {
      this.$emit("input", val);
      this.$emit("change", val);
    },
  },
};
</script>
